export const EXTERNAL_ROUTES = {
  MARKETING_ABOUT_US: 'https://www.pestshare.com/about-us/',
  MARKETING_ROOT: 'https://www.pestshare.com/',
  MARKETING_RESIDENTS: 'https://www.pestshare.com/residents/',
} as const
